import React from "react";
import training from "../assets/images/training2.jpeg";
import service from "../assets/images/service2.jpeg";
import { Link } from "react-router-dom";

const Range = () => {
  return (
    <section className="range">
      <Link to="/training" className="range__item">
        <div className="range__item__imgCon">
          <img src={training} alt="Healthcare training programs" />
        </div>
        <div className="range__item__disc">
          <div>
            <p>Explore our programmes</p>
            <h5>Training</h5>
          </div>

          <i className="bx bx-arrow-right"></i>
        </div>
      </Link>
      <Link to="/services" className="range__item">
        <div className="range__item__imgCon">
          <img src={service} alt="Medical equipment services" />
        </div>
        <div className="range__item__disc">
          <div>
            <p>Discover what we offer</p>
            <h5>Services</h5>
          </div>

          <i className="bx bx-arrow-right"></i>
        </div>
      </Link>
    </section>
  );
};

export default Range;
